/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { FacebookShare, RedditShare, TwitterShare } from '@gatsbyonfire/components';
import React from 'react';

export default function ShareArticle({ post, center }) {
  return (
    <React.Fragment>
      <h3
        className={`uppercase text-xl text-gray-600 tracking-wide ${center ? 'text-center' : ''}`}
      >
        Share article
      </h3>
      <div className={`flex flex-wrap ${center ? 'justify-center' : ''}`}>
        <TwitterShare text={post.frontmatter.title} via="juvoni">
          {({ link }) => (
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:shadow-lg hover:bg-twitter border-1 border-twitter rounded-lg text-white my-2 mr-3 px-6 py-2"
              css={css`
                width: 150px;
                background-color: var(--btnAction);
              `}
            >
              <i className="fab fa-twitter" />{' '}
              <span className="inline-block ml-2 font-sans text-sm">Twitter</span>
            </a>
          )}
        </TwitterShare>
        <FacebookShare>
          {({ link }) => (
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:shadow-lg hover:bg-facebook border-1 border-facebook rounded-lg text-white my-2 mr-3 px-6 py-2"
              css={css`
                width: 150px;
                background-color: var(--btnAction);
              `}
            >
              <i className="fab fa-facebook-f" />{' '}
              <span className="inline-block ml-2 font-sans text-sm">Facebook</span>
            </a>
          )}
        </FacebookShare>
        <RedditShare title={post.frontmatter.title}>
          {({ link }) => (
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:shadow-lg hover:bg-reddit border-1 border-reddit rounded-lg text-white my-2 mr-3 px-6 py-2"
              css={css`
                width: 150px;
                background-color: var(--btnAction);
              `}
            >
              <i className="fab fa-reddit" />{' '}
              <span className="inline-block ml-2 font-sans text-sm">Reddit</span>
            </a>
          )}
        </RedditShare>
      </div>
    </React.Fragment>
  );
}
